import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  applySnippet(event) {
    const button = event.currentTarget
    const field = button.dataset.field
    const text = button.dataset.text
    const contractType = button.dataset.contractType
    
    // Finde das entsprechende Formularfeld
    let targetField
    
    switch (field) {
      case 'description':
        targetField = this.element.querySelector('[name*="[description]"]')
        break
      case 'terms':
        targetField = this.element.querySelector('[name*="[terms]"]')
        break
      case 'footer':
        targetField = this.element.querySelector('[name*="[footer]"]')
        break
      default:
        return
    }
    
    if (targetField) {
      // Setze den Text in das Feld
      if (targetField.tagName === 'TEXTAREA' || targetField.type === 'text') {
        targetField.value = text
      } else if (targetField.classList.contains('trix-content')) {
        // Für Rich Text Felder (Trix)
        const trixEditor = targetField.closest('.trix-editor')
        if (trixEditor) {
          trixEditor.editor.loadHTML(text)
        }
      }
      
      // Zeige eine Bestätigung
      this.showNotification(`Snippet für ${field} angewendet`)
      
      // Aktualisiere die Vertragsart
      const contractTypeField = this.element.querySelector('[name*="[contract_type]"]')
      if (contractTypeField) {
        contractTypeField.value = contractType
        // Trigger change event für andere Event-Listener
        contractTypeField.dispatchEvent(new Event('change'))
      }
    }
  }
  
  showNotification(message) {
    // Einfache Benachrichtigung
    const notification = document.createElement('div')
    notification.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded shadow-lg z-50'
    notification.textContent = message
    
    document.body.appendChild(notification)
    
    setTimeout(() => {
      notification.remove()
    }, 3000)
  }
}





